import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import RequestForm from '@/components/RequestForm';
import { useIsMobile } from '@/hooks/use-mobile';
import { useTranslation } from 'react-i18next';
import { useDirection } from '@/providers/DirectionProvider';

interface RequestDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onRequestCreated?: () => Promise<void>;
}

const RequestDialog: React.FC<RequestDialogProps> = ({
  isOpen,
  onOpenChange,
  onRequestCreated
}) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const { direction } = useDirection();

  const handleSuccess = async () => {
    onOpenChange(false);
    if (onRequestCreated) {
      await onRequestCreated();
    }
  };

  // Mobile - use Drawer for better UX with proper swipe support
  if (isMobile) {
    return (
      <Drawer open={isOpen} onOpenChange={onOpenChange}>
        <DrawerContent dir={direction} className="max-h-[85vh] rounded-t-2xl bg-slate-50">
          <DrawerHeader className="p-4 pb-0">
            <DrawerTitle className="text-xl">{t('requestDialog.createNewRequest')}</DrawerTitle>
          </DrawerHeader>
          <div className="flex-1 overflow-y-auto px-4 pb-20 max-h-[calc(85vh-80px)]">
            <RequestForm onSuccess={handleSuccess} />
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  // Desktop - use Dialog
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent dir={direction} className="max-w-3xl max-h-[90vh] p-0 overflow-hidden bg-slate-50">
        <DialogHeader className="p-4 pb-0">
          <DialogTitle className="text-xl">{t('requestDialog.createNewRequest')}</DialogTitle>
        </DialogHeader>
        <div className="overflow-y-auto h-[calc(90vh-80px)] w-full">
          <div className="p-4 bg-gray-50 py-0">
            <RequestForm onSuccess={handleSuccess} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RequestDialog;
